(function ($) {

	'use strict';

	/**
	 * function to turn the password recovery page into a lightbox 
	 */
	$.initPasswordLightbox = function () {
		var ajaxUrl = '/forgotpass.php?ajax=1';

		$('a[href="/forgotpass.php"]').off('click.pwlightbox').on('click.pwlightbox', function(e){
			e.preventDefault();
			
			var $lb = $('<div class="lb_forgotpassword wrapper" />');
			var $markup;
			
			// get form markup
			$.ajax({
				url: ajaxUrl,
				type: 'GET',
				dataType: 'json',
				success: function (result) {
					if (result.status === true && result.markup.length > 0) {
						$markup = $(result.markup);
						$markup.find('script').remove();
						
						$.loadLightboxJs(function () {
							$lb.lightbox_me_start($markup, {
								closeClick: false,
								onLoad: function () {

									$('#forgotpassform').on('submit', function(e){
										e.preventDefault();
										var data = $(this).serialize();
										$(this).find(':input').prop('disabled', true);
console.log('submit elem:', $(this), 'data:', data);
										$.submitForgotPass(ajaxUrl, data);
									});
								},
								onClose: function () {
									$lb.remove();
								}
							});
						});
						
					} else if (result.status === 'error') {
						if (result.code === 400) {
							// output an error code in the lightbox
						}
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error(textStatus + ': ' + errorThrown);
				}

			});
		});
	}; // $.fn.initPasswordLightbox
	
	$.submitForgotPass = function (ajaxUrl, data){
		// post call, replace lightbox content with result
		$.ajax({
			url: ajaxUrl,
			type: 'POST',
			dataType: 'json',
			data: data,
				success: function (result) {
					if (result.status === true && result.markup.length > 0) {
						var $markup = $(result.markup);
						$markup.find('script').remove();
						$('#forgotpass-container').html($markup);
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.error(textStatus + ': ' + errorThrown);
					$('#forgotpass-container').find('p').html(errorThrown);
				}
		});
	};

}(jQuery));